// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"244":"d179a374","270":"700af3e6","304":"6a06be5d","560":"ead7c282","778":"0b77a5ca","810":"1e7166ab"}[chunkId] + ".css";
};